import React from 'react';

const Order = () => {
    return (
        <div>
            <h3>order will show here</h3>
        </div>
    );
};

export default Order;